import {
  Button,
  Col,
  Divider,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import {
  Descriptions,
  DescriptionsItem,
  HeaderPrintForm,
} from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, {useEffect, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppSelector} from "redux/hooks";
import {columns} from "./config";
import "./ReturnModal.scss";
import {
  formatDateToString,
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeToFixed,
  getAge,
} from "helper/common";
import {CURRENCY_LOCALE, FORMAT_TIME} from "types/enums";
const ReturnModal = props => {
  const {closeModal, getDetailPrescription} = props;
  const printRef = useRef<any>();

  const detailBill = useAppSelector(state => state.glassKiot.detailBill);
  useEffect(() => {}, [detailBill]);
  const fields1 = [
    {label: "Họ và tên", value: detailBill?.glassesSalesDto?.hoTen},
    {
      label: "Ngày sinh",
      value: formatDateToString(
        detailBill?.glassesSalesDto?.ngaySinh,
        FORMAT_TIME.dayFull
      ),
    },
    {label: "Tuổi", value: getAge(detailBill?.glassesSalesDto?.ngaySinh)},
    {
      label: "Giới tính",
      value:
        detailBill?.glassesSalesDto?.gioiTinh == 0
          ? "Nam"
          : detailBill?.glassesSalesDto?.gioiTinh == 1
          ? "Nữ"
          : "--",
    },
    {label: "Điện thoại", value: detailBill?.glassesSalesDto?.dienThoai},
    {label: "Mã bệnh nhân", value: detailBill?.glassesSalesDto?.maBenhNhan},
    {label: "Mã phiếu khám", value: detailBill?.glassesSalesDto?.maKB},
    {label: "Bác sĩ", value: detailBill?.glassesSalesDto?.tenBacSy},
    {label: "Địa chỉ", value: detailBill?.glassesSalesDto?.diaChi},
    {label: "Ghi chú", value: detailBill?.glassesSalesDto?.ghiChu},
  ];
  useEffect(() => {
    console.log(detailBill);
  }, [detailBill]);

  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="bill-modal print-form">
      <div ref={printRef} className="print-modal">
        <HeaderPrintForm></HeaderPrintForm>
        <div>
          <div style={{marginBottom: 12}}>
            <Row justify={"center"}>
              <Typography.Title
                style={{
                  fontWeight: "700",
                  fontSize: 30,
                }}
              >
                PHIẾU HOÀN TRẢ
              </Typography.Title>
            </Row>
            <Row>
              <Col span={20}>
                <Descriptions
                  size="small"
                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}
                >
                  {/* <Row wrap={true} style={{width: "100%"}}> */}
                  {fields1 &&
                    fields1.map(e => (
                      // <Col span={12}>
                      <DescriptionsItem label={e.label}>
                        {e?.value ?? "--"}
                      </DescriptionsItem>
                      // </Col>
                    ))}
                  {/* </Row> */}
                </Descriptions>
              </Col>

              <Col span={4}>
                <QRCode
                  value={detailBill?.glassesSalesDto?.maBenhNhan}
                  size={120}
                />
              </Col>
            </Row>
          </div>
          <div className="container2" style={{marginBottom: 12}}>
            <Row>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 20,
                  marginBottom: 12,
                }}
              ></Typography.Text>
            </Row>
            <Table
              className="table-print"
              bordered
              columns={columns}
              dataSource={detailBill?.listGlassesSalesDetailDto}
              pagination={false}
            ></Table>
          </div>

          <div className="container2" style={{marginBottom: 12}}>
            <Row justify={"end"}>
              <div>
                Số tiền hoàn trả:{" "}
                <span className="value">
                  {formatToCurrencyTypeToFixed(
                    detailBill?.glassesSalesDto?.tongTienHoanTra,
                    0,
                    CURRENCY_LOCALE.TYPE_DE
                  )}
                  đ
                </span>
              </div>
            </Row>
          </div>

          <Sign
            span={8}
            time={detailBill?.glassesSalesDto?.thoiGianTra}
            nguoiThucHien={detailBill?.glassesSalesDto?.nvBanHang}
            label="Người bán kính"
          ></Sign>
        </div>
      </div>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="bill-modal print-form"
            onAfterPrint={closeModal}
          />
        </Space>
      </Row>
    </div>
  );
};
export default ReturnModal;
